import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { MembershipLevelRosterCapConfirmation } from '@/pages/MembershipLevelsPage.types'

export function RosterCapChangeDialog({
  confirmation,
  pending,
  onClose,
  onConfirm,
}: {
  confirmation: MembershipLevelRosterCapConfirmation
  pending: boolean
  onClose: () => void
  onConfirm: () => void
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Lower {confirmation.level.name} Roster cap?</DialogTitle>
          <DialogDescription>
            These Organizations already exceed the new cap of {confirmation.warning.new_cap}. Their
            existing people will keep their member status, but no new people can be added until
            their Roster is below the cap.
          </DialogDescription>
        </DialogHeader>
        <Alert variant="warning" className="flex flex-col gap-2">
          <span className="font-medium">Over-cap Rosters</span>
          <ul className="list-disc pl-5">
            {confirmation.warning.organizations.map((organization) => (
              <li key={organization.name}>
                {organization.name}: {organization.roster_size} people
              </li>
            ))}
          </ul>
        </Alert>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" disabled={pending} onClick={onConfirm}>
            {pending ? 'Saving...' : 'Save cap'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
